





























































import moment from "moment";
import {Component, Prop, Vue} from "vue-property-decorator";
import KInput from "../components/KInput.vue";
import {Settings as SettingsObj} from "../models/Settings";
import {MINUTES} from "../utils";
import AdminNav from "../components/AdminNav.vue";
import TopNav from "../components/TopNav.vue";
import {verifyAuth, apiGet} from "../session";

@Component({
    components: {KInput, AdminNav, TopNav},
})
export default class Users extends Vue {
    protected users: any[] = [];

    public created() {
        verifyAuth();
        apiGet("/users").then((u: any) => {
            this.users = u;
        });
    }
}
